/**
 * Sitemap Service
 * Handles sitemap regeneration notifications and triggers
 */

export const sitemapService = {
    /**
     * Notify about sitemap update needed
     * Since we're on a static deployment, sitemap updates happen during build
     */
    notifyUpdate: () => {
        console.log('📍 Sitemap will be automatically regenerated on next deployment');
        return {
            success: true,
            message: 'Sitemap will be updated on next deployment'
        };
    },

    /**
     * Trigger sitemap regeneration in development
     */
    regenerateInDev: async () => {
        if (process.env.NODE_ENV === 'development') {
            try {
                // In development, we can use Node.js to regenerate but cannot invoke child_process in the browser.
                console.log('Sitemap regeneration is handled via build scripts.');
                return { success: true, message: 'Sitemap will regenerate on build.' };
            } catch (error) {
                console.error('Error in sitemap regeneration:', error);
                return { success: false, error: error.message };
            }
        } else {
            // In production, just notify
            return sitemapService.notifyUpdate();
        }
    },

    /**
     * Show success message for blog post operations
     */
    showUpdateMessage: () => {
        return `✅ Blog post saved successfully!\n\n📍 Note: The sitemap will be automatically updated when you deploy your site.\n\nRun "npm run build" to regenerate the sitemap locally.`;
    }
};

